import React from "react";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../../components/TCText/TCText";
import UpArrow from "../../../assets/up_arrow.png";

type Props = {
  statsValue: string;
};

export const ClutterGraphTopSectionItem: React.FC<Props> = ({ statsValue }) => {
  return (
    <div style={styles.shotPatternInnerContainer}>
      <TCText style={styles.value} value={statsValue} />
      <img src={UpArrow} style={styles.image} alt="" />
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  shotPatternInnerContainer: {
    flex: 1, // take equal width
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // center horizontally
    justifyContent: "center", // center vertically
  },
  image: {
    width: "33px",
    height: "50px",
    objectFit: "contain",
  },
  value: {
    fontWeight: 600,
    fontSize: "18px",
    color: Colors.black,
  },
};
